import { render, staticRenderFns } from "./TasksRowChart.vue?vue&type=template&id=2080d842&scoped=true"
import script from "./TasksRowChart.vue?vue&type=script&lang=js"
export * from "./TasksRowChart.vue?vue&type=script&lang=js"
import style0 from "./TasksRowChart.vue?vue&type=style&index=0&id=2080d842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2080d842",
  null
  
)

export default component.exports